import notification from './notification';
/**
 * API Actions
 */

import axios from 'axios';
import { SERVER as Server, APP_DOMAIN } from '../config';
;


export const apiErrorHandler = (error, history) => {

    if (error?.status === 401 || (error?.status === 403 && (error?.data?.detail === "Not authenticated" || error?.data?.detail === "ACCESSTOKEN_HAS_EXPIRED"))) {

        notification['error']({
            message: 'Session Expired',
            description: "Please login to continue",
        });
        history('/login');
    }
    // else if (error?.status === 403) {
    //     notification['warning']({
    //         message: 'No access',
    //         description: "No access to this resource.",
    //     });
    //     history('/dashboard');
    // }
    else {
        // in some of the cases it seems to return a 503 status code. So ignore this.
        console.error('Unknow status code: ', error?.status);
        console.error(error);
        // history('/login');
        // notification['error']({
        //     message: 'Unknown system error',
        //     description: "Refresh the page and try again. If the problem persists, contact the our support team.",
        // });
    }
};

// Check if user has been loggedin, setup the Bearer token for all API calls
axios.interceptors.request.use(config => {
    const data = config;

    // set up the REACT_REMOTE_APP_DOMAIN header.
    // data.headers.remote_app_domain = APP_DOMAIN;

    // set up the REACT_REMOTE_APP_DOMAIN header.
    data.headers.app_admin = APP_DOMAIN;

    if ("authentication" in sessionStorage) {
        const localdata = sessionStorage.getItem('authentication');
        const idToken = JSON.parse(localdata);

        if (idToken?.access_token) {
            data.headers.Authorization = `Bearer ${idToken?.access_token}`;
        }

        return Promise.resolve(data);
    } else {
        return Promise.resolve(data);
    }
});

export const get = (endpoint, config = null) => {
    return (
        axios({
            url: Server + endpoint,
            method: 'get',
            responseType: 'json',
            ...config,
        })
            .then(response => response)
            .catch(error => Promise.reject(error.response))
    );
};


export const post = (endpoint, data, config = null) => {
    return (
        axios({
            url: Server + endpoint,
            method: 'post',
            responseType: 'json',
            data,
            ...config,
        })
            .then(response => response)
            .catch(error => Promise.reject(error.response))
    );
};

export const put = (endpoint, data, config = null) => {
    return (
        axios({
            url: Server + endpoint,
            method: 'put',
            responseType: 'json',
            data,
            ...config,
        })
            .then(response => response)
            .catch(error => Promise.reject(error.response))
    );
};

export const remove = (endpoint, data, config = null) => {
    return (
        axios({
            url: Server + endpoint,
            method: 'delete',
            responseType: 'json',
            data,
            ...config,
        })
            .then(response => response)
            .catch(error => {
                Promise.reject(error)
            })
    );
};
